import { useState } from "react";

import { useScrollPosition } from "@n8tb1t/use-scroll-position";

export const useScrollDirection = () => {
  const [direction, setDirection] = useState("up");
  useScrollPosition(
    ({ prevPos, currPos }) => {
      if (currPos.y >= prevPos.y || currPos.y === 0) {
        setDirection("up");
      } else {
        setDirection("down");
      }
    },
    [],
    false,
    false,
    300,
  );

  return direction;
};
